<template>
  <div class="relative">
    <button
      type="button"
      class="relative z-10 block rounded-full stroke-gray-600 overflow-hidden focus:outline-none hover:stroke-SharesquareBlue"
      :class="{ 'stroke-SharesquareBlue': isOpen }"
      @click="isOpen = !isOpen"
      @keydown.esc="isOpen = false"
    >
      <div class="flex items-center capitalize flex-row">
        <UserCircleIcon class="mr-2 h-8 text-SharesquareBlue" />
        <span> {{ authStore.user?.full_name }}</span>
      </div>
    </button>
    <button
      v-if="isOpen"
      class="fixed inset-0 w-full h-full cursor-default"
      tabindex="-1"
      @click="isOpen = false"
    ></button>
    <div
      v-if="isOpen"
      class="absolute z-50 right-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-xl"
    >
      <a
        href="javascript:void(0);"
        class="block px-4 py-2 text-gray-800 hover:bg-SharesquareBlue hover:text-white"
        @click="goToAccount"
        >{{ $t('COMPONENT_LAYOUT_BREADCRUMBS_ACCOUNT') }}</a
      >
      <!-- <a
        href="#"
        class="block px-4 py-2 text-gray-800 hover:bg-SharesquareBlue hover:text-white"
        >Support</a
      > -->
      <a
        href="javascript:void(0);"
        class="block px-4 py-2 text-gray-800 hover:bg-SharesquareBlue hover:text-white"
        @click="openReferFriend"
        >Refer a friend</a
      >
      <a
        href="javascript:void(0)"
        class="block px-4 py-2 text-gray-800 hover:bg-SharesquareBlue hover:text-white"
        @click="logout"
        >{{ $t('COMPONENT_LAYOUT_HEADER_LOGOUT') }}</a
      >
    </div>
  </div>
</template>

<script>
import { UserCircleIcon } from '@heroicons/vue/24/outline'
import { useAuthStore } from '~/store/auth/state'

export default {
  name: 'DropDownMenu',
  components: {
    UserCircleIcon,
  },
  data() {
    return {
      isOpen: false,
      authStore: useAuthStore(),
    }
  },
  methods: {
    goToAccount() {
      this.isOpen = false
      this.$router.push({ name: 'account' })
    },
    openReferFriend() {
      this.isOpen = false
      this.$router.push({ name: 'refer-a-friend' })
    },
    async logout() {
      await this.$auth.logout()
    },
  },
}
</script>

<style></style>
